var map = {
	"./affiliations_and_insurances.png": "9e6c",
	"./alert_in_media.png": "27ca",
	"./criminal_record.png": "9ca5",
	"./international_background.png": "d539",
	"./legal_background.png": "c8f7",
	"./personal_identity.png": "2b1e",
	"./politically_exposed_person.png": "3205",
	"./professional_background.png": "3d96",
	"./taxes_and_finances.png": "28a0"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "e838";